"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = _interopRequireDefault(require("./Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledDropdown = _styledComponents.default.div.attrs({
  "data-qa": "styled-dropdown"
}).withConfig({
  displayName: "DropdownArrow__StyledDropdown",
  componentId: "sc-1pzic7i-0"
})(["display:flex;align-items:center;margin-left:7px;width:9px;height:5px;fill:", ";"], function (props) {
  return props.theme.carvana.blue.dark;
});

var _ref2 = _react.default.createElement(_Icons.default, {
  iconName: "dropdownArrow"
});

var DropdownArrow = function DropdownArrow(_ref) {
  var className = _ref.className;
  return _react.default.createElement(StyledDropdown, {
    className: className,
    "data-qa": "dropdown-arrow"
  }, _ref2);
};

DropdownArrow.defaultProps = {
  className: ''
};
var _default = DropdownArrow;
exports.default = _default;
module.exports = exports.default;